var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPlayingBlock)?_c('div',{staticClass:"fab-container"},[_c('div',{class:['audio-fab', '-' + _vm.playingBlock.state],on:{"click":function($event){return _vm.onAudioFab()}}},[(_vm.playingBlock.state === 'pause')?_c('i',{staticClass:"fab-play"}):_vm._e(),_vm._v(" "),(_vm.playingBlock.state === 'play')?_c('i',{staticClass:"fab-pause"}):_vm._e()])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82cd471a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/books/details/AudioFAB.vue
// module id = 1045
// module chunks = 6